import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import { TimelineLabelType } from "../../../constants/ComponentTypes";
import ArrowDropdown from '../../Icons/ArrowDropdown';
import moment from "moment";
import { connect } from 'react-redux';
import { isSalesDemo } from "../../../utils/userUtils";

const styles = () => ({
  root: {
    display: "flex",
  },

  item: {
    display: "flex",
    alignItems: "center",
  },

  name: {
    fontSize: "11px",
  },

  arrow: {
    transform: "rotate(-90deg)",
  },
});

class LetterOrderProgress extends React.Component {
  render() {
    const { classes, status } = this.props;
    let progresses = []

    if (isSalesDemo(this.props.user) && status && status.letter_order_address && status.status_label_type === TimelineLabelType.APPROACH.value) {
      // セールスデモかつレター送付の場合かつ注文受付のステータスの場合は、発送済みのステータスを表示する
      progresses = [
        TimelineLabelType.APPROACH,
        TimelineLabelType.PROOFREAD_CREATED,
        TimelineLabelType.ORDER_PRINTING,
        TimelineLabelType.ORDER_SHIPPED,
      ];
    } else if (status.status_label_type === TimelineLabelType.RESERVE.value) {
      progresses = [
        TimelineLabelType.RESERVE,
      ];
    } else if (status.status_label_type === TimelineLabelType.APPROACH.value) {
      progresses = [
        TimelineLabelType.APPROACH,
      ];
    } else if (status.status_label_type === TimelineLabelType.PROOFREAD_CREATED.value) {
      progresses = [
        TimelineLabelType.APPROACH,
        TimelineLabelType.PROOFREAD_CREATED,
      ];
    } else if (status.status_label_type === TimelineLabelType.ORDER_PRINTING.value) {
      progresses = [
        TimelineLabelType.APPROACH,
        TimelineLabelType.PROOFREAD_CREATED,
        TimelineLabelType.ORDER_PRINTING,
      ];
    } else if (status.status_label_type === TimelineLabelType.ORDER_SHIPPED.value) {
      progresses = [
        TimelineLabelType.APPROACH,
        TimelineLabelType.PROOFREAD_CREATED,
        TimelineLabelType.ORDER_PRINTING,
        TimelineLabelType.ORDER_SHIPPED,
      ];
    } else {
      // クライアントユーザー作成や、フォローコールで作成されるものはnullで返す
      return null;
    }

    return (
      <div className={classes.root}>
        {progresses.map((item, i) => {
          let isLast = (i === progresses.length - 1);
          return (
            <div className={classes.item} key={i}>
              <div className={classes.name} style={{ color: !isLast ? "#71737B" : "#1A65FF" }}>
                {item.text} {isLast && ("(" + moment(status.created_at).format("YYYY/MM/DD") + ")")}
              </div>
              {!isLast && (
                <ArrowDropdown width={20} height={20} color={'#71737B'} className={classes.arrow} />
              )}
            </div>
          )
        })}
      </div>
    )
  }
}

LetterOrderProgress.propTypes = {
  classes: PropTypes.object.isRequired,
  status: PropTypes.object.isRequired,
  user: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    user: state.accountSetting.user,
  };
};

export default withStyles(styles)(connect(
  mapStateToProps
)(LetterOrderProgress));


// WEBPACK FOOTER //
// ./src/components/Timeline/parts/LetterOrderProgress.jsx